module.exports = __webpack_public_path__ + "static/media/eildh2.ddea7312.jpg";